import React from 'react';
import PropTypes from 'prop-types';
import styles from './SectionDivider.scss'

const SectionDivider = ({ title }) => {
  return (
    <div className={styles.divider}>{ title }</div>
  );
};

SectionDivider.propTypes = {
 title: PropTypes.string,
 className: PropTypes.string
};

SectionDivider.defaultProps = {
    title: '',
    className: ''
};

export default SectionDivider;
